/**
 * Single source of truth for the app-supported EVM network (web).
 * Production runs on Ethereum mainnet (chain 1).
 */
export const SUPPORTED_NETWORK_NAME = 'Ethereum Mainnet';

export const SUPPORTED_CHAIN_ID = 1;
export const SUPPORTED_CHAIN_ID_HEX = '0x1' as const;
